import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en.json";
import svTranslation from "./locales/sv.json";

const resources = {
  en: { translation: enTranslation },
  sv: { translation: svTranslation },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "sv", // Default language
  fallbackLng: "en", // If translation is missing, use English
  interpolation: { escapeValue: false },
});

export default i18n;